import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export default class TagOrUntagCustomerActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({
            addingTags: this.addingTags = [],
            removingTags: this.removingTags = [],
        } = fields);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            addingTags: this.addingTags,
            removingTags: this.removingTags,
        };
    }
}
